module.exports = __webpack_public_path__ + "static/img/4-bg.e8a3323.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4-bg.png
// module id = /sCA
// module chunks = 0